import { render, staticRenderFns } from "./ProductOrderInvoiceDocumentPopUp.vue?vue&type=template&id=1b7a84d1&scoped=true&"
import script from "./ProductOrderInvoiceDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderInvoiceDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderInvoiceDocumentPopUp.vue?vue&type=style&index=0&id=1b7a84d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a84d1",
  null
  
)

export default component.exports